import * as React from 'react';
import { injectFont } from './injectFont';
export default class CustomFont extends React.PureComponent {
  constructor() {
    super(...arguments);
    // Injects a locally-hosted font
    this.componentDidMount = () => {
      const { primaryFont = '', secondaryFonts = [], injectCss } = this.props;
      injectFont(primaryFont, secondaryFonts);
      injectCss();
    };
  }
  render() {
    return null;
  }
}
//# sourceMappingURL=CustomFont.js.map
